class ShippingCalculator extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.response = this.querySelector('.shipping-calculator__response');
    this.message = this.querySelector('[data-shipping-calculator-message]');
    this.rates = this.querySelector('[data-shipping-calculator-rates]');

    if (window.Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer',
      });
    }

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculateRates();
    });
  }

  async calculateRates() {
    const address = new URLSearchParams(new FormData(this.form));
    this.setLoading(true);
    this.clearResponse();

    try {
      const prepareResponse = await fetch(`${this.dataset.cartUrl}/prepare_shipping_rates.json`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: address,
      });

      if (!prepareResponse.ok) throw await this.responseError(prepareResponse);

      const rates = await this.fetchRates(address);
      this.displayRates(rates.shipping_rates || []);
    } catch (error) {
      this.showMessage(error.message || 'Shipping rates could not be calculated. Please try again.', true);
    } finally {
      this.setLoading(false);
    }
  }

  async fetchRates(address, attempts = 0) {
    const response = await fetch(`${this.dataset.cartUrl}/shipping_rates.json?${address.toString()}`, {
      headers: { Accept: 'application/json' },
    });

    if (response.status === 202 && attempts < 10) {
      await new Promise((resolve) => window.setTimeout(resolve, 500));
      return this.fetchRates(address, attempts + 1);
    }

    if (!response.ok) throw await this.responseError(response);
    return response.json();
  }

  async responseError(response) {
    try {
      const data = await response.json();
      const errors = data.shipping_address || data.errors || data;
      return new Error(typeof errors === 'string' ? errors : Object.values(errors).flat().join(' '));
    } catch (error) {
      return new Error('Shipping rates could not be calculated. Please try again.');
    }
  }

  displayRates(rates) {
    if (!rates.length) {
      this.showMessage('No shipping rates are available for this address.');
      return;
    }

    this.showMessage('Available shipping rates:');
    rates.forEach((rate) => {
      const item = document.createElement('li');
      item.textContent = `${rate.name}: ${this.formatPrice(rate.price)}`;
      this.rates.appendChild(item);
    });
  }

  formatPrice(price) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang, {
        style: 'currency',
        currency: this.dataset.currencyCode,
      }).format(Number(price));
    } catch (error) {
      return price;
    }
  }

  clearResponse() {
    this.response.hidden = true;
    this.message.textContent = '';
    this.message.classList.remove('shipping-calculator__message--error');
    this.rates.replaceChildren();
  }

  showMessage(message, isError = false) {
    this.response.hidden = false;
    this.message.textContent = message;
    this.message.classList.toggle('shipping-calculator__message--error', isError);
  }

  setLoading(isLoading) {
    this.submitButton.disabled = isLoading;
    this.submitButton.classList.toggle('loading', isLoading);
    this.submitButton.setAttribute('aria-busy', String(isLoading));
  }
}

if (!customElements.get('shipping-calculator')) {
  customElements.define('shipping-calculator', ShippingCalculator);
}
